module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"complete":" ","incomplete":"Jetzt bewerten"},"en":{"complete":" ","incomplete":"Evaluate now"}}')
  delete Component.options._Ctor
}
